module.exports = __webpack_public_path__ + "static/media/female_vs_male_life_expectancy.11449388.png";